import type { Housings } from "gql/api";

export function computeHousingLabel(
  housing: Partial<Housings> | undefined | null
): string {
  if (!housing) return "";
  return `${housing.housing_number} / ${housing.stage_count}`;
}
